import Vue from 'vue'
import 'jquery-mask-plugin'

export const fnMask = {
    date: (el) => {
        window.jQuery(el).mask(`00/00/0000`, { placeholder: `__/__/____`, clearIfNotMatch: true })
    },
    time: (el) => {
        window.jQuery(el).mask(`00:00`, { placeholder: `__:__`, clearIfNotMatch: true })
    },
    datetime: (el) => {
        window.jQuery(el).mask(`00/00/0000 00:00`, { placeholder: `__/__/____ __:__`, clearIfNotMatch: true })
    },
    phone: (el) => {
        window.jQuery(el).mask(`# ###0 0000`, { reverse: true, clearIfNotMatch: true })
    },
    money: (el) => {
        window.jQuery(el).mask(`#.##0,00`, { reverse: true, placeholder: `_,__`, clearIfNotMatch: true })
    },
    percentage: (el) => {
        window.jQuery(el).mask(`#.##0,00`, { reverse: true, placeholder: `_,__`, clearIfNotMatch: true })
    },
    number: (el) => {
        window.jQuery(el).mask(`0#`)
    }
}

Vue.directive('pml-mask', {
    bind: function (el, binding) {
        try {
            fnMask[binding.value](el)
        } catch (e) {
            let clearIfNotMatch = el.dataset.clearIfNotMatch !== 'false'
            let placeholder = el.dataset.placeholder || ''
            window.jQuery(el).mask(binding.value, { placeholder, clearIfNotMatch })
        }
    },
    unbind: function (el) {
        window.jQuery(el).unmask()
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/input-mask.js